import { format, parse } from 'date-fns';

import { BffBrandType } from '@src/lib/__generated/sdk';
import { ExtendedProvider } from './ProviderDetailsPage';

export const getProviderHeroTitle = ({
	firstName,
	lastName,
	middleName,
	educations,
	brand,
	degreeName,
}: ExtendedProvider) => {
	let updatedDegree = '';

	if (brand === BffBrandType.ClearChoice) {
		const { degreeName, degreeNames } = educations?.[0] ?? {};
		const degreeList = (degreeNames ?? []).filter(Boolean);
		const degreeDisplay = degreeList.length ? degreeList.join(', ') : degreeName;
		updatedDegree = degreeDisplay ? `, ${degreeDisplay}` : '';
	} else {
		updatedDegree = degreeName ? `, ${degreeName}` : ''; // for AD, display the degreeName field
	}

	const updatedMiddleName = middleName ? `${middleName.charAt(0)}. ` : '';
	return `Dr. ${firstName ?? ''} ${updatedMiddleName}${lastName ?? ''}${updatedDegree}`;
};

export const getProviderAboutTitle = ({ firstName, lastName }: ExtendedProvider) => {
	return `About Dr. ${firstName ?? ''} ${lastName ?? ''}`;
};

export const getProviderAboutSubTitleList = (provider: ExtendedProvider, config: BrandThemeConfig) => {
	return [
		{
			value: provider.mainWorkerFunction ? provider.mainWorkerFunction : '',
		},
		{
			value: provider.degreeName ? provider.degreeName : '',
		},
		{
			value: provider.stateLicense ? provider.stateLicense : '',
		},
		{
			value:
				provider.workerType && provider.workerType !== 'Employee'
					? provider.workerType === 'Contingent Worker'
						? `Independent Contractor at ${config.name}`
						: provider.workerType
					: '',
		},
	];
};

export const getProviderOfficesTitle = ({ lastName }: ExtendedProvider) => {
	return `Offices associated with Dr. ${lastName ?? ''}`;
};

export const getProviderEducationDetails = (provider: ExtendedProvider) => {
	return provider.collegeName ? `${provider.collegeName}, ${provider.degreeName}` : undefined;
};

export const getProviderLanguages = (provider: ExtendedProvider) => {
	return provider.languages && provider.languages.length > 0 ? provider.languages.join(', ') : undefined;
};

export const getProviderHireDate = (provider: ExtendedProvider) => {
	if (!provider.hireDate) return undefined;

	// Extract the date portion only (YYYY-MM-DD)
	const dateOnly = provider.hireDate.split('T')[0];

	const date = parse(dateOnly, 'yyyy-MM-dd', new Date());

	return format(date, 'MMMM yyyy');
};
